// extracted by mini-css-extract-plugin
module.exports = {"root":"OverflowingTextTip_root__BpNQK","oneLine":"OverflowingTextTip_oneLine__vMP73"};